$(document).ready(function () {

  // Appel des sliders photo sur la fiche produit
  $('.block_metafield_block_4 .pictures_block .pictures').slick({
    lazyLoad: 'progressive',
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.product-recommendations-placeholder').slick();

});

// Fonction pour afficher le texte de description d'une page liste en entier
function readMore() {

  const body = document.getElementsByTagName('body')

  if (body[0].classList.contains('template-collection')) {
    let link = document.querySelector('.enlarge-text .read-more')
    let text = document.querySelector('.enlarge-text .text')

    if (link != null) {

      if (text.clientHeight > 90) { // Si la zone de texte est trop grande alors on affiche le lien read more
        text.classList.add('active')
      } else {
        link.style.display = "block"
      }

      link.addEventListener('click', function () {
        text.classList.add('active')
        this.style.display = "none"
      })
    }
  }
};

// Appel de la fonction readMore
readMore()


// Fonction pour afficher/masquer les caracteristiques produit
function ShowCaract() {

  const body = document.querySelector('body')

  if (body.classList.contains('template-product') == true) {

    const wrapper = document.querySelector('.caracteristiques')
    // let buttonWrapper = document.createElement('p')
    // let buttonHTML = document.createElement('span')

    // const TextOff = "See all the information"
    // const TextOn = "Hide information"

    // buttonWrapper.classList.add('action-caract')

    // wrapper.after(buttonWrapper)
    // buttonWrapper.innerHTML = '<span></span>'

    // var buttonSpan = document.querySelector('.action-caract span')
    // buttonSpan.innerText = TextOff

    // buttonSpan.addEventListener('click', function() {
    wrapper.classList.toggle('active')

    // if( wrapper.classList.contains('active') ) {
    //   buttonSpan.innerText = TextOn
    // } else {
    //   buttonSpan.innerText = TextOff
    // }
  }
}


// Appel de la fonction ShowCaract
ShowCaract()

$(document).ready(function () {
  var weareintemplateproduct = document.getElementsByClassName('template-product');
  if (weareintemplateproduct.length > 0) {
    load_compisitionsblock();
  }
});

var weareintemplateproduct = document.getElementsByClassName('template-product');
if (weareintemplateproduct.length > 0) {
  load_compisitionsblock();
}

// Systéme pour afficher le return top button
var btn_top = $('#return-top');
btn_top.on('click', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, '300');
});
$(window).scroll(function () {
  if ($(window).scrollTop() > 1000) {
    btn_top.addClass('show-return-top');
  } else {
    btn_top.removeClass('show-return-top');
  }
});
// Fin

const urlParams = new URLSearchParams(window.location.search);
const collectionPage = urlParams.get('page');
if (collectionPage > 1) {
  $('.rte').hide();
}

function changevariant(e) {
  let urlPrincipale = window.location.hostname;
  let all_variant = e.parentNode.children;
  let value = e.children[0].innerHTML;
  let value_json = JSON.parse(value);
  let MainFrame = e.closest('.grid-item__content');
  //let MainFrame_Img = MainFrame.children[0].children[0].children[0];
  let MainFrame_Img = MainFrame.querySelector('.grid-product__image-wrap img');
  let MainFrame_subtitle = MainFrame.querySelector('.grid-item-label .grid-product__vendor');
  let MainFrame_title = MainFrame.querySelector('.grid-item-label .grid-product__title');
  let MainFrame_price = MainFrame.querySelector('.grid-product__price--current span:first-child');
  let MainFrame_link = MainFrame.querySelector('a');
  let new_link = value_json.collection_url + "/products/" + value_json.url;
  let new_img = value_json.image;
  let new_subtitle = value_json.sub_title;
  let new_title = value_json.title;
  let new_price = value_json.price;
  for (let i = 0; i < all_variant.length; i++) {
    all_variant[i].style.border = "none";
  }
  e.style.border = "1px solid #001E28";
  MainFrame_link.href = new_link;
  MainFrame_Img.srcset = new_img;
  MainFrame_subtitle.innerHTML = new_subtitle;
  MainFrame_title.innerHTML = new_title;
  MainFrame_price.innerHTML = theme.Currency.formatMoney(new_price * 100);
}

let dark_modal = document.getElementsByClassName("variant_dark_modal");
// variant_close_button_a
if (document.getElementsByClassName("modify_a").length > 0) {
  let variant_modify_a = document.getElementsByClassName("modify_a");
  let variant_close_button_a = document.getElementsByClassName("variant_close_button_a");
  dark_modal[0].addEventListener("click", function () { hide_variant_list(); });
  variant_close_button_a[0].addEventListener("click", function () { hide_variant_list(); });
  variant_modify_a[0].addEventListener("click", function () { variantlist("a"); });
}

// variant_close_button_b
if (document.getElementsByClassName("modify_b").length > 0) {
  let variant_modify_b = document.getElementsByClassName("modify_b");
  let variant_close_button_b = document.getElementsByClassName("variant_close_button_b");
  dark_modal[1].addEventListener("click", function () { hide_variant_list(); });
  variant_close_button_b[0].addEventListener("click", function () { hide_variant_list(); });
  variant_modify_b[0].addEventListener("click", function () { variantlist("b"); });
}

function hide_variant_list() {
  //document.getElementsByClassName("variant_select_a")[0].style.display = "none";
  document.getElementsByClassName("variant_select_a")[0].classList.remove('active');
  setTimeout(function () {
    document.querySelector(".variant_select_a .variant_list_pick").style.transform = "translateX(496px)";
  }, 300);

  document.getElementsByClassName("variant_select_b")[0].classList.remove('active');
  setTimeout(function () {
    document.querySelector(".variant_select_b .variant_list_pick").style.transform = "translateX(496px)";
  }, 300);
  document.body.style.overflow = "scroll";
}

function variantlist(e) {
  if (e == "a") {
    //document.getElementsByClassName("variant_select_a")[0].style.display = "flex";
    document.getElementsByClassName("variant_select_a")[0].classList.add('active');
    setTimeout(function () {
      document.querySelector(".variant_select_a .variant_list_pick").style.transform = "translateX(0)";
    }, 300);

    //document.getElementsByClassName("variant_list_pick")[0].style.overflow = "scroll";
    document.body.style.overflow = 'hidden';
  }
  else if (e == "b") {
    document.getElementsByClassName("variant_select_b")[0].classList.add('active');
    setTimeout(function () {
      document.querySelector(".variant_select_b .variant_list_pick").style.transform = "translateX(0)";
    }, 300);
    document.body.style.overflow = 'hidden';
  }
}

function load_compisitionsblock() {

  const currentDir = document.querySelector('html').getAttribute('dir')

  if (currentDir == 'rtl') {
    const dirRTL = true

    $('.product-compositions').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      rtl: true,
      responsive: [
        {
          breakpoint: 831,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false
          }
        }
      ]
    });

  } else {
    const dirRTL = false

    $('.product-compositions').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 831,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false
          }
        }
      ]
    });

  }

  slideIndex = 0;

}

$(document).ready(function () {

  $("img.lazyload").lazyload();

});

function fermetureMenu() {
  $(document).on('click', '.svgCroixFermeture', function (e) {
    document.querySelector('.collection-filter__btn')?.click()
  });

  $(document).on('click', '.collection-filter__btn', function (e) {
    document.querySelector('#CollectionInlineFilterWrap .filter-wrapper')?.classList.remove('is-transitioning');
  });
}

var attente = 500;

// DEBUT lancement document
$(document).ready(function () {

  fermetureMenu();
  suite();
  testtest();
  step = $(".step").data("step");

  if (step == "payment_method") {
    $(".condition-terms").show();

    $("#continue_button").on("click", function () {
      if (($("#agree").is(":checked"))) {
        $(".erreur_coche").hide();
        $(this).submit();
      } else {
        $(".erreur_coche").show();
        return false;
      }
    });
    if (window.location.hostname === 'naterial.de') {
      var labelElement = document.querySelector('.radio__label.payment-method-wrapper > label');
      if (labelElement) {
        labelElement.textContent = 'Kreditkarten, Sofortüberweisung oder Giropay';
      }
    }
  }

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    attente = 1;
    $(".site-nav__expanded-item").on("touchend", function () {
      maDiv = $(this);
      parentDiv = maDiv.parent();
      sousMenu_Grisee(parentDiv);
      maDiv.find("a").addClass("menu_selected");
      ajoutDiv2();
    });

    //Mode PC
  } else {
    $(".site-nav__expanded-item").on("mouseover", function () {
      maDiv = $(this);
      setTimeout(function () {
        ajoutDiv();
      }, attente);
    });
    $(".site-navigation").on("mouseleave", function () {
      $(document).find(".menuVisible").removeClass("menuVisible");
      attente = 500;
    });
    $(".collapsibles-wrapper > div > a").addClass("btn");
    $(".collapsibles-wrapper > div > a").addClass("btnWhite");
  }
});
// FIN lancement document


//DEBUT fonction ajout div au menu
function ajoutDiv() {
  $(".menuVisible").removeClass(".menuVisible");
  $(".site-nav__expanded-item").on("mouseover", function () { });

  if (maDiv.is(":hover") == true) {
    attente = 0;
    $(document).find(".menuVisible").removeClass("menuVisible");
    fils = maDiv.find(".site-nav__dropdown");
    fils.addClass("menuVisible");
    fils.find(".site-nav__dropdown-animate").addClass("textVisible");
  } else {
    $(document).find(".menuVisible").removeClass("menuVisible");
  }
  return attente;
}

//ajoutDivMoobile
function ajoutDiv2() {
  $(".menuVisible").removeClass(".menuVisible");
  $(".site-nav__expanded-item").on("mouseover", function () { });
  $(document).find(".menuVisible").removeClass("menuVisible");
  fils = maDiv.find(".site-nav__dropdown");
  fils.addClass("menuVisible");
  fils.find(".site-nav__dropdown-animate").addClass("textVisible");

  return attente;
}

function cleanMenu(parent) {
  enfant = parent.children();
  enfant2 = enfant.children();
  enfant2.removeClass("menu_selected");
  enfant2.removeClass("menu_grey");
}

function sousMenu_Grisee(parent) {
  enfant = parent.children();
  enfant2 = enfant.children();
  enfant2.removeClass("menu_selected");
  enfant2.addClass("menu_grey");
}

function modifSlider() {
  $(".secondary-slide:nth-child(2)").style.left = "50%";
}

function testtest() {
  var myString = $(".product__description").text();
  var result = myString.indexOf("Download assembly instructions");
  if (result > -1) {
    test = myString.substr(0, result);
    $(".product__description").html(test);
  }
}

function removeImage() {
  test = $(
    " div.our-essentials__product-images > div > div > div > div > div.grid-item.grid-product.slick-slide.slick-current.slick-active > div > a > div.grid-product__image-wrap > div"
  );
  test2 = $("div.our-essentials__product-images img");
  test2.hide();
}

function suite() {
  if (window.innerWidth > 768) {
    $(".mobile-scroll").css("display", "none");
    /*  var taille = $("#product-recommendations-placeholder").height();
    console.log(taille);
    var height = $(window).height();
  height = height/20;
  console.log(height);
    valeurtaille = taille;
  console.log(valeurtaille);
    var negatif = "-";
    var pixel = "px";
    var chaineTotalePositif = "".concat(taille).concat(pixel);
    var chaineTotaleNegatif = negatif.concat(chaineTotalePositif);
  console.log(chaineTotaleNegatif);
    el = document.querySelector("div > div.page-width.page-width--flush-small > center");
    el.style.marginTop=chaineTotaleNegatif;
    el.style.marginBottom=chaineTotalePositif;
*/
  }
}
